export default __webpack_public_path__ + "static/media/shopifyNativeConcent6.d7c7a3ab.svg";